"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _Disable2FAForm = _interopRequireDefault(require("./Disable2FAForm"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Disable2FAModal = function Disable2FAModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("auth"),
    t = _useTranslation.t;
  var handleSubmit = props.handleSubmit,
    submitting = props.submitting,
    isOpen = props.isOpen,
    close = props.close,
    changeFieldValue = props.changeFieldValue;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t("Disable Two-Factor Authentication"),
    onCancel: function onCancel() {
      close();
      changeFieldValue('enableTwoFactorAuth', 'use2FA', true);
    },
    close: close
  }, /*#__PURE__*/_react["default"].createElement(_Disable2FAForm["default"], {
    handleSubmit: handleSubmit,
    submitting: submitting
  }));
};
Disable2FAModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};
Disable2FAModal.propTypes = {
  close: _propTypes["default"].func.isRequired,
  handleSubmit: _propTypes["default"].func
};
var _default = exports["default"] = Disable2FAModal;